import React, { useContext, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import {
  DataServiceContext,
  SiteConfigContext,
  useClientContext,
  useEditorStatusContext
} from '@bingads-webui-campaign-react/smart-page-context';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import {
  ResponsiveMode,
  getEnabledComponentsConfig,
  navigateToEditingComponent,
} from '@bingads-webui-campaign-react/smart-component-util';

import { SiteBuilderInternal } from './site-builder-internal';
import { getStyles } from './styles';

export const SiteBuilder = withErrorView((props) => {
  const serverContext = useContext(DataServiceContext);
  const { siteConfig, dispatchSiteConfig } = useContext(SiteConfigContext);
  const { responsiveMode } = useClientContext();

  const [{ editingComponentType, editingComponentId } = {}] = useEditorStatusContext() || [];

  const onRenderCompleted = useCallback(({
    orderedComponentsInPages,
  }) => {
    dispatchSiteConfig({
      type: 'UPDATE_ORDERED_COMPONENTS',
      payload: orderedComponentsInPages,
    });

    if (editingComponentType && editingComponentId) {
      // If we run navigateToEditingComponent function immediately,
      // the scroll element's offsetHeight we get is lower than its real height.
      // this caused the element can't be scrolled to the center.
      // use setTimeout to let the element can be scrolled to the center.
      setTimeout(() => {
        navigateToEditingComponent(editingComponentId, editingComponentType, siteConfig);
      }, 0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchSiteConfig, editingComponentId, editingComponentType]);

  const classes = useDefaultStyles(getStyles);
  const enabledComponentsConfig =
    useMemo(() => getEnabledComponentsConfig(serverContext), [serverContext]);

  const siteBuilderInternal = useMemo(() => (
    <SiteBuilderInternal
      enabledComponentsConfig={enabledComponentsConfig}
      pages={siteConfig.pages}
      websiteSourceData={siteConfig.websiteSourceData}
      onRenderCompleted={onRenderCompleted}
      componentsMapping={props.componentsMapping}
      className={classNames(
        classes.container,
        responsiveMode === ResponsiveMode.LargeDesktop && classes.largeDesktopContainer
      )}
    />
  ), [
    classes, enabledComponentsConfig, onRenderCompleted,
    props.componentsMapping, responsiveMode, siteConfig.pages, siteConfig.websiteSourceData,
  ]);

  return siteBuilderInternal;
}, 'pageMode');
